import { useTranslation } from '@frontend/i18n';
import { useAudienceTray } from '../providers/audience-tray-provider';
import { InteractiveListItem } from './interactive-list-item';

type Props = {
  cancelCreateList: () => void;
  finishCreateList: (name: string) => void;
};

export const NewListItem = ({ cancelCreateList, finishCreateList }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const { trackingIdPrefix } = useAudienceTray();

  return (
    <InteractiveListItem
      actionText={t('Create List')}
      cancelTrackingId={`${trackingIdPrefix}-new-list-item-cancel-btn`}
      onCancel={cancelCreateList}
      onSave={finishCreateList}
      saveTrackingId={`${trackingIdPrefix}-new-list-item-save-btn`}
    />
  );
};
